// extracted by mini-css-extract-plugin
module.exports = {"ackGroup":"style_ackGroup__2kSYx","groupName":"style_groupName__1crjg","member":"style_member__2RM4u"};